<h4>Confirm Action</h4>
<p><small>This action cannot be undone, are you sure you want to continue this user ?</small></p>

<div mat-dialog-actions>
    <button mat-button (click)="onNoClick()" cdkFocusInitial><strong>No, Cancel</strong></button>
    <button style="letter-spacing:1px;color: red;" mat-button [mat-dialog-close]="true"><small>Continue</small></button>
</div>